export const events = {
  READYCHECK: 'readycheck',
  MAINREADY: 'mainready',
  IFRAMEREADY: 'iframeready',
  STATEUPDATE: 'stateupdate',
  USERDATAUPDATE: 'userdataupdate',
  DATAREQUESTED: 'datarequested',
  COLLECTIONREQUESTED: 'collectionrequested',
  COLLECTIONPAGEREQUESTED: 'collectionpagerequested',
  MODELREQUESTED: 'modelrequested',
  SEARCHRESULTREQUESTED: 'searchresultrequested',
  DATARETURNED: 'datareturned',
  KOLIBRIDATARETURNED: 'kolibridatareturned',
  NAVIGATETO: 'navigateTo',
  CONTEXT: 'context',
  THEMECHANGED: 'themechanged',
  KOLIBRIVERSIONREQUESTED: 'kolibriversionrequested',
  CHANNELMETADATAREQUESTED: 'channelmetadatarequested',
  CHANNELFILTEROPTIONSREQUESTED: 'channelfilteroptionsrequested',
  RANDOMCOLLECTIONREQUESTED: 'randomcollectionrequested',
  NOW: 'now',
  RESIZE: 'resize',
  LOADING: 'loading',
  ERROR: 'error',
  BLOOMPAGESREAD: 'Pages Read',
};

export const DataTypes = {
  MODEL: 'Model',
  SEARCHRESULT: 'SearchResult',
  COLLECTION: 'Collection',
  COLLECTIONPAGE: 'CollectionPage',
  KOLIBRIVERSION: 'KolibriVersion',
  CHANNELMETADATA: 'ChannelMetadata',
  CHANNELFILTEROPTIONS: 'ChannelFilterOptions',
  RANDOMCOLLECTION: 'RandomCollection',
};

export const MessageStatuses = {
  FAILURE: 'failure',
  SUCCESS: 'success',
};

export const nameSpace = 'hashi';
